export const socialAuthURL = '/token/social'
export const passwordResetURL = '/customers/reset'
export const newMapiRefreshTokenURL = '/jwt/refresh'
export const getUpdatedTermsAndPrivacyURL = '/customers/customers/v2/getShortUserProfileForTCV2'
export const patchUpdateTermsAndPrivacyURL = '/customers/addAcceptedTermsForUser'
export const getUserProfileURL = '/customers/v2/profile'
export const missingFeedbackUrl = '/customers/orders/feedback/pending' // TO DO: Move to Orders
export const loggingUrl = '/logging/log'
export const getClientTokensforSignin = '/jwt/token'
export const updateUserProfileURL = '/customers/customers/updateProfile'
export const getTokenPaypalVenmoURL = '/payment/get/client-token'
export const getClientTokenForEmailVerification = 'auth/token'
export const mfaAuthOTPGenerate = '/mfa/login/otp/generate'
export const mfaAuthOTPVerify = '/mfa/login/otp/verify'
export const mfaAuthOTPVerifyRegister = '/customers/v2/verify'
export const revokeTokenURL = '/revoke_token/'
